import { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { useLenis } from '@/lib/useLenis';
import Nav from '@/components/site/Nav';
import Hero from '@/components/site/Hero';
import Marquee from '@/components/site/Marquee';
import Services from '@/components/site/Services';
import Process from '@/components/site/Process';
import Pricing from '@/components/site/Pricing';
import Faq from '@/components/site/Faq';
import Contact from '@/components/site/Contact';
import Footer from '@/components/site/Footer';
import LoadingScreen from '@/components/site/LoadingScreen';
import { useContent } from '@/context/ContentContext';

export default function Landing() {
  useLenis();
  const { t, loading } = useContent();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    // Fallback: hide loader after 2.2s regardless
    const timer = setTimeout(() => setShowLoader(false), 2200);
    return () => clearTimeout(timer);
  }, []);

  if (loading && !t) {
    return <LoadingScreen onDone={() => {}} />;
  }

  return (
    <div className="grain relative">
      <AnimatePresence>
        {showLoader && <LoadingScreen onDone={() => setShowLoader(false)} />}
      </AnimatePresence>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Process />
        <Pricing />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
